<template>
  <div>
    <el-select
      v-model="port_id"
      filterable
      :size="size"
      :placeholder="placeTitle"
      remote
      :remote-method="remoteMethod"
      :clearable="clearable"
      :disabled="disabled"
      :loading="loading"
      :style="{ width: width }"
      :default-first-option='true'
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="`[${item.code}]${item.name_zh}`"
        :value="item.id"
      >
        <div>[{{ item.code }}] {{ item.name_zh }}</div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "shipCompany",
  props: {
    width: {
      type: String,
      default: "",
    },
    placeTitle: {
      type: String,
      default: "",
    },
    value: {
      type: String | Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: { //类型：1-结算代理；2-报关公司；3-车队；5-指定代理；6-海外代理；7-订舱代理；8-船代；10-船公司
      type: String | Number,
      default: 10,
    },
  },
  data() {
    return {
      options: [],
      port_id: null,
      loading: false,
    };
  },
  mounted() {
    this.handleInitValue();
  },
  watch: {
    port_id(nv) {
      if (nv == "") {
        this.options = [];
      }
      this.$emit("input", nv);
    },
    value(nv){
        if(nv){
            this.handleInitValue()
        }
    }
  },
  methods: {
    selectClear(){
      this.options=[],
      this.port_id=null
    },
    async handleInitValue() {
      if (this.value != "") {
        let parmas = {};
        parmas.id = this.value;
        let res = await this.$store.dispatch("API_bookingSpace/cooperativePartnerQuery", parmas);
          this.loading = false;
          if (res.success) {
            this.options = res.data;
            this.port_id=this.value
          }
      } else {
        // this.port_id=this.value
      }
    },
    async remoteMethod(queryString) {
      this.loading = true;
      let parmas = {};
      parmas.keyword = queryString;
      parmas.type = this.type;
      parmas.limit = 20;
      parmas.start = 0;
      let res = await this.$store.dispatch("API_bookingSpace/cooperativePartnerQuery", parmas);
      this.loading = false;
      if (res.success) {
        this.options = res.data;
      }
    },
  },
};
</script>

<style scoped>
</style>
